// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@adl/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@adl/XDL/Utilities";
import translate from "@insite/client-framework/Translate";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import { css } from "styled-components";

headerStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

headerStyles.invoiceCountGridItem = {
    ...myAccountFilterSectionStyles.countGridItem,
};
headerStyles.toggleFilterButtonIcon = {
    ...myAccountFilterSectionStyles.toggleFilterIcon,
};

headerStyles.toggleFilterGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.toggleFilterGridItem, {
        css: css`
            &:after {
                content: "";
            }
            button[data-test-selector="invoiceHistory_toggleFilter"] {
                ${myAccountFilterSectionStyles.toggleFilterButton?.css}
                min-width: 205px;
                width: auto;
                &:after {
                    content: "${translate("Search Invoices")}";
                    font-weight: bold;
                }
            }
        `,
    }),
};
